
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class TaskDialog extends SiteEntityDialog<TaskRow, any> {
        protected getFormKey() { return TaskForm.formKey; }
        protected getIdProperty() { return TaskRow.idProperty; }
        protected getLocalTextPrefix() { return TaskRow.localTextPrefix; }
        protected getNameProperty() { return TaskRow.nameProperty; }
        protected getService() { return TaskService.baseUrl; }

        protected form = new TaskForm(this.idPrefix);

    }
}